import { SessionRepository } from "../../infra/repository/session.repository";
import { DrillSessionQuotaExceededError } from "../errors/drill-session-quota-exceeded.error";
import { DRILL_SESSION_QUOTA_EXCEEDED } from "../../../../common/session-quota/drill-session-quota";
import { HttpStatusCode } from "../../../../common/infra/http-status/http-status";

export interface CreateSessionOutput {
    id: string;
    name: string;
    qrcode: string;
    workoutId: string;
    link: string;
}

export class CreateSessionUseCase {
    static async execute(workoutId: string, name: string, captureReactionTime: boolean): Promise<CreateSessionOutput> {
        try {
            const response = await SessionRepository.createSession(workoutId, name, captureReactionTime);
            if (
                response.status === HttpStatusCode.FORBIDDEN &&
                response.code === DRILL_SESSION_QUOTA_EXCEEDED
            ) {
                throw new DrillSessionQuotaExceededError(
                    response.drillId ?? "",
                    response.executionsUsed ?? 0,
                    response.executionsLimit ?? 0
                );
            }
            if (response?.error) throw Error("Erro ao obter QR Code da sessão");
            return response.data;
        } catch (error) {
            if (error instanceof DrillSessionQuotaExceededError) {
                throw error;
            }
            throw Error("Erro ao obter QR Code da sessão");
        }
    }
}
